export default "__VITE_ASSET__CsCd8SR8__"